import { render } from "./SubmitMenu.vue?vue&type=template&id=acae07f0&scoped=true"
import script from "./SubmitMenu.vue?vue&type=script&lang=js"
export * from "./SubmitMenu.vue?vue&type=script&lang=js"

import "./SubmitMenu.vue?vue&type=style&index=0&id=acae07f0&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acae07f0"]])

export default __exports__